exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\niframe[data-v-3bdccb99] {\n    width: 100%;\n    height: 700px;\n    border: 0;\n    overflow: hidden;\n}\n", ""]);

